export default "__VITE_ASSET__Chs7rLX2__"